// Flyin Brand Colors
export const BRAND_PRIMARY = '#3366cc'
export const BRAND_PRIMARY_DARK = '#1f4299'
export const BRAND_PRIMARY_LIGHT = '#7db3f0'
export const BRAND_SECONDARY = '#F66826'
export const BRAND_SECONDARY_DARK = '#cc4d1a'
export const BRAND_SECONDARY_LIGHT = '#ff9966'
export const BRAND_PRIMARY_100 = '#e6f0ff'

//borders
export const BORDER_MAIN = '#e5e7eb'
export const BORDER_SECONDARY = '#d1d5db'

// neutral scale
export const WHITE = '#fff'
export const BLACK = '#000'
export const NEUTRAL_100 = '#f9fafb'

//text
export const TEXT_PRIMARY = '#000'
export const TEXT_SECONDARY = '#4b5563'
export const TEXT_SUBHEADING = '#6b7280'
export const TEXT_DISABLED = '#9ca3af'
export const TEXT_SUBTITLE = '#374151'

//link
export const LINK_MAIN = '#2463EB'

//error
export const ERROR_MAIN = '#dc2626'
export const ERROR_LIGHT = '#fef2f2' // Very light red background

//success
export const SUCCESS_MAIN = '#16a34a'
export const SUCCESS_LIGHT = '#f0fdf4' // Very light green background

// warning
export const WARNING_MAIN = '#f2bf42'

//sign-in promo banner
export const SIGN_IN_PROMO_BANNER_BG = 'linear-gradient(90deg, #FEF6E7 0%, #FBE3C3 100%)'
export const SIGN_IN_PROMO_BANNER_PILL_BG = '#FAEEDC'
export const SIGN_IN_PROMO_BANNER_PILL_BORDER = '#F2DFC2'
export const SIGN_IN_PROMO_BANNER_CTA_BG = '#E2581E'
export const SIGN_IN_PROMO_BANNER_CTA_HOVER_BG = '#C94B15'

//seat layout
export const SEAT_LAYOUT_COLORS_0 = '#d9f1e8'
export const SEAT_LAYOUT_COLORS_1 = '#A4CDFF'
export const SEAT_LAYOUT_COLORS_2 = '#9db6e6'
export const SEAT_LAYOUT_COLORS_3 = '#5F8EEE'
export const SEAT_LAYOUT_COLORS_4 = '#985289'
export const SEAT_LAYOUT_COLORS_5 = '#4D1A37'
export const UNAVAILABLE_SEAT_COLOR = '#BDBDBD'
